module.exports = {

  enableBodyScroll: function(){
    document.body.classList.toggle('body-scroll-disabled',false);
  },

  disableBodyScroll: function(){
    document.body.classList.toggle('body-scroll-disabled',true);
  }
}
